import { styled } from 'styled-components';

// Left column, showing field icons and labels
export const Dt = styled.dt`
  font-weight: 600;
`;
